import { cn } from "@/lib/utils.ts";
import { ReactNode } from "react";
import { useMuiModal } from "./modal";
import { useNetworkStatus } from "@/hooks/use-network-status";
import { NotAvailableInOfflineModeModal } from "./not-available-in-offline-mode-modal";

export function ServiceCard({
  img,
  title,
  className,
  onClick: onClick,
  disabledInOfflineMode,
}: {
  img: string;
  title: ReactNode;
  className?: string;
  onClick?: () => void;
  disabledInOfflineMode?: boolean;
}) {
  const { showModal } = useMuiModal();
  const networkStatus = useNetworkStatus();

  const isOfflineDisabled =
    disabledInOfflineMode && networkStatus.data === "disconnected";

  return (
    <div
      className={cn(
        `relative border-2 border-bub-vivid-blue rounded bg-white pb-8 shadow-xl w-full max-w-[318px]`,
        isOfflineDisabled && "opacity-50",
        className,
      )}
      onClick={() => {
        if (isOfflineDisabled) {
          showModal(<NotAvailableInOfflineModeModal />);
          return;
        }
        onClick?.();
      }}
    >
      <img src={img} className={`w-full h-[12vh]`} />
      <p className={`font-helvetica text-bub-vivid-blue text-3xl text-center`}>
        {title}
      </p>
      {isOfflineDisabled && (
        <span className="absolute inset-0 flex items-center justify-center pointer-events-none text-red-600 font-bold text-[120px] leading-none">
          ✕
        </span>
      )}
    </div>
  );
}
